








import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AnalysesTabs from "../analyses-tabs/AnalysesTabs.vue";
import { Analysis, FarmAnalysis } from "@/api/analyses/types";

@Component({
  name: "AnalysesController",
  components: {
    AnalysesTabs,
  },
})
export default class AnalysesController extends Vue {
  @Prop({ type: String, default: "" }) private ownerName!: string;
  @Prop({ type: String, default: "" }) private farmName!: string;
  @Prop({ type: String, default: "" }) private source?: string;

  private get analysis(): Analysis {
    return this.$store.state.analyses.analysesContext;
  }

  private get farmAnalysisList() {
    return this.analysis?.farmAnalyses || [];
  }
}
